import React from "react";

import Tooltip from "core/Tooltip";
import Flexbox from "core/Flexbox";
import Question from "core/ReusableIcons/Question";

export const headerData = [
    { title: "Month" }, // month
    { title: "Earned" }, // totalEarned
    { title: "Paid" }, // totalPaid
    {
        title: (
            <Flexbox
                flexDirection="column"
                justifyContent="center"
                alignItems="flex-start"
            >
                <div>Full-Res Sales</div>
                <Tooltip message="Single purchases at $33 each. You earn $19.80 per sale.">
                    <Question size="sm" />
                </Tooltip>
            </Flexbox>
        )
    }, // fullResSales
    {
        title: (
            <Flexbox
                flexDirection="column"
                justifyContent="center"
                alignItems="flex-start"
            >
                <div>Large Sold</div>
                <Tooltip message="Single purchases at $8.50 each. You earn $5.10 per sale.">
                    <Question size="sm" />
                </Tooltip>
            </Flexbox>
        )
    }, // largeSales
    {
        title: (
            <Flexbox
                flexDirection="column"
                justifyContent="center"
                alignItems="flex-start"
            >
                <div>Attribution</div>
                <div>Downloads</div>
                <Tooltip message="Low-res free downloads. User must credit you if licensed Creative Commons.">
                    <Question size="sm" />
                </Tooltip>
            </Flexbox>
        )
    }, // freeDownloadCount
    { title: "Details" }, // insightExists
    { title: "PDF" } //
];
